const HideSubdomain = function() {
    /**
     * "-1": "noSite",
        "0": "AgentWebsite",
        "1": "TeamSite",
        "2": "BrokerSite",
        "3": "SubSite",
        "4": "HESite"
     */
    /**
     * groupItems: Refers site/pages/page-template.js middle setting configuration item
     */
    let ins = null;
    const HAVE_SUB_SETTING_KEY = 'haveSubSetting';
    const SHOW_IN_SUBDOMAIN_KEY = 'showInSubdomain';
    const SHOW_IN_SUBDOMAIN_SETTING_ID = 'showInSubdomain';
    const SUB_SITE = 'SubSite';
    const SHOW_SUBDOMAIN_CHECKBOX_SITETYPE = [
        'TeamSite',
        'DepartmentSite',
        'CompanySite'
    ];
    class _HideSubdomain {
        // menu:init menuList:openMenuSetting PageSetting:init AddPageDialog:settingSave
        constructor(siteType, isSSRServer = false) {
            if (!ins) {
                this.siteType = siteType || '';
                this.hasSubdomains = SHOW_SUBDOMAIN_CHECKBOX_SITETYPE.includes(
                    this.siteType
                );
                ins = this;
            }
            if (!isSSRServer) {
                window && (window.hideSubdomain = ins);
            }
            return ins;
        }

        //  according to nodel and link initialization menu configuration ，data:{menus:[],hiden:[]}
        initMenu(data) {
            let resetMenuSubdomain = localStorage.getItem('resetMenu') == 1;
            // 1. delete HAVE_SUB_SETTING_KEY & SHOW_IN_SUBDOMAIN_KEY
            resetMenuSubdomain && this._resetMenus(data);
            // 2. init HAVE_SUB_SETTING_KEY & SHOW_IN_SUBDOMAIN_KEY
            if (this.hasSubdomains) {
                const initMenuItem = item => {
                    item[HAVE_SUB_SETTING_KEY] = this.canEditSetting(item);
                    item[SHOW_IN_SUBDOMAIN_KEY] =
                        SHOW_IN_SUBDOMAIN_KEY in item
                            ? item[SHOW_IN_SUBDOMAIN_KEY]
                            : true;
                };
                this.forMenus(data.menus, initMenuItem);
                this.forMenus(data.hidden, initMenuItem);
            }
        }

        //  Substation filtering menu
        filterMenu(data) {
            if (this.siteType === SUB_SITE) {
                this.applySetting(data.hidden);
                this.applySetting(data.menus);
            }
        }

        generaSetting(checked, urlSpan = 12) {
            let item = {
                defaultValue: [],
                value: [],
                values: [
                    {
                        id: 'true',
                        name: 'Show on Agent Subdomain(s)'
                    }
                ],
                id: SHOW_IN_SUBDOMAIN_SETTING_ID,
                name: '',
                placeholder: '',
                span: 12,
                type: 'checkbox',
                options: {
                    style: {
                        'margin-top': '-42px'
                    }
                }
            };
            if (urlSpan === 24) {
                item.options.style.transform = 'translateX(100%)';
                item.options.style['max-width'] = '50%';
            }
            if (checked === true) {
                item.defaultValue.push('true');
                item.value.push('true');
            }

            return item;
        }

        //  click setting, have subdomain configuration ， initialization setting configuration
        initSetting(menu, groupItems) {
            let span = this.findUrlSpan(groupItems);
            if (this.hasSubdomains) {
                if (menu && menu[HAVE_SUB_SETTING_KEY]) {
                    const checked =
                        menu[SHOW_IN_SUBDOMAIN_KEY] &&
                        menu[SHOW_IN_SUBDOMAIN_KEY] === true;
                    const setting = this.generaSetting(checked, span);
                    if (!menu.nbrId) {
                        groupItems[0].fileds.push(setting);
                    } else {
                        groupItems[0].fileds.splice(-1, 0, setting);
                    }
                }
                //  Add page default setting for true
                if (!menu) {
                    groupItems[0].fileds.push(this.generaSetting(true, span));
                }
            }
        }

        // copy page setting  By default, based on the current page's subdomain Configuration initialization  copy page
        // copy none show on subdomain When configuring the page ， Added by default show on subdomain configuration item and selected
        copyPageSetting(menu, groupItems) {
            let span = this.findUrlSpan(groupItems);
            if (this.hasSubdomains) {
                if (menu) {
                    let checked = true;
                    if (
                        menu[HAVE_SUB_SETTING_KEY] &&
                        menu[SHOW_IN_SUBDOMAIN_KEY] === false
                    ) {
                        checked = false;
                    }

                    groupItems[0].fileds.push(
                        this.generaSetting(checked, span)
                    );
                }
            }
        }

        // settingSave update when menu of showInSubdomain configuration
        // add page  initialization haveSubSetting = true
        updateMenu(type, menu, menuInfo) {
            if (this.hasSubdomains) {
                if (type === 'copy') {
                    menu[HAVE_SUB_SETTING_KEY] = true;
                    menu[SHOW_IN_SUBDOMAIN_KEY] =
                        menuInfo[SHOW_IN_SUBDOMAIN_SETTING_ID] &&
                        !!menuInfo[SHOW_IN_SUBDOMAIN_SETTING_ID].length;
                } else {
                    // add
                    !(HAVE_SUB_SETTING_KEY in menu) &&
                        (menu[HAVE_SUB_SETTING_KEY] = true);
                    // update
                    menu &&
                        menuInfo &&
                        (menu[SHOW_IN_SUBDOMAIN_KEY] =
                            menuInfo[SHOW_IN_SUBDOMAIN_SETTING_ID] &&
                            !!menuInfo[SHOW_IN_SUBDOMAIN_SETTING_ID].length);
                }
            }
        }

        // add page - link Type default sync
        setLink(menu, menuInfo) {
            if (this.hasSubdomains) {
                Object.assign(menu, {
                    haveSubSetting: true,
                    [SHOW_IN_SUBDOMAIN_SETTING_ID]:
                        menuInfo[SHOW_IN_SUBDOMAIN_SETTING_ID] &&
                        !!menuInfo[SHOW_IN_SUBDOMAIN_SETTING_ID].length
                });
            }
        }

        // site
        applySetting(menus) {
            menus = menus || [];
            if (menus.length) {
                //  find out hide of menu hide
                const addParentKey = true;
                this.forMenus(
                    menus,
                    menu => {
                        let parent = menu['parent'] || null;
                        let index = -1,
                            showFlag =
                                typeof menu[SHOW_IN_SUBDOMAIN_KEY] === 'boolean'
                                    ? menu[SHOW_IN_SUBDOMAIN_KEY]
                                    : true;
                        delete menu.parent;
                        if (menu[HAVE_SUB_SETTING_KEY] && !showFlag) {
                            if (parent) {
                                index = parent.items.findIndex(
                                    val => val.name === menu.name
                                );
                                if (index !== -1) {
                                    parent.items.splice(index, 1);
                                    !parent.items.length &&
                                        menus.splice(menus.indexOf(parent), 1);
                                }
                            } else {
                                index = menus.findIndex(
                                    val => val.name === menu.name
                                );
                                menus.splice(index, 1);
                            }
                        }
                    },
                    addParentKey
                );
            }
        }

        // setting Is there  show in subdomain  options
        canEditSetting(menu) {
            const nonGroupPage = menu.source !== 'offices'
            return !menu.nodel && menu.link !== '/' && nonGroupPage;
        }

        forMenus(menus, callback, addParentKey = false) {
            if (!menus || !menus.length) {
                return; 
            }
            let stack = [];
            for (let i = 0; i < menus.length; i++) {
                stack.push(menus[i]);
            }
            let set = new WeakSet();
            while (stack.length) {
                let item = stack.shift();
                if (set.has(item)) {
                    console.warn('menu is circle !!');
                    continue;
                }
                set.add(item);
                if (item['items'] && item['items'].length) {
                    addParentKey &&
                        item['items'].forEach(v => (v.parent = item));
                    stack.unshift(...item['items']);
                } else {
                    callback(item);
                }
            }
        }

        findUrlSpan(groupItems) {
            let span = 12;
            groupItems &&
                groupItems[0] &&
                (span = groupItems[0].fileds.filter(v => v.id === 'url')) &&
                (span = span[0].span);
            return span;
        }

        _resetMenus(data) {
            this.forMenus(data.menus, item => {
                delete item[HAVE_SUB_SETTING_KEY];
            });
            this.forMenus(data.hidden, item => {
                delete item[HAVE_SUB_SETTING_KEY];
            });
        }
    }

    return _HideSubdomain;
};

export default HideSubdomain();
